import { useEffect, useState } from 'react';
import { getServerUrl } from '../utils/getServerUrl';
import { useUniversalNavContext } from './useUniversalNavContext';

import type { UniversalNavLinkType } from '../constants';

export const useSidebarLinkData = () => {
  const { getFullyQualifiedURL } = useUniversalNavContext();
  const [sideNavData, setSideNavData] = useState<UniversalNavLinkType[]>([]);

  useEffect(() => {
    let apiSubscribed = true;

    async function getSidebarUrlData() {
      const serverUrl = getServerUrl();
      const sidebarUrl = `${serverUrl}/navigation-data/sidebar`;

      let userId = '0';

      try {
        const sessionResult = await fetch(
          getFullyQualifiedURL('/api/v4/session/') as string
        );
        const session = await sessionResult.json();

        if (session.id) {
          userId = session.id;
        }
      } catch {
        // proceed regardless
      }

      try {
        const response = await fetch(sidebarUrl, {
          headers: { 'x-customuser-id': userId },
        });
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          setSideNavData(data);
        }
      } catch (error) {
        if (apiSubscribed) {
          setSideNavData([]);
        }
      }
    }

    getSidebarUrlData();

    return () => {
      apiSubscribed = false;
    };
  }, [getFullyQualifiedURL]);

  return { sideNavData };
};
